import LinearProgress from '@mui/material/LinearProgress'
import { Suspense, ElementType } from 'react'
import { styled } from '@mui/material/styles'
import { TunsolvedAny } from '../../types/unsolved'

const LoaderWrapper = styled('div')({
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 1301,
  width: '100%',
})

const Loader = () => (
  <LoaderWrapper>
    <LinearProgress color="primary" />
  </LoaderWrapper>
)

const Loadable = (Component: ElementType) => (props: TunsolvedAny) =>
  (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  )

export default Loadable
